export default [

    {
        path: '/kpi-assessment',
        name: 'KpiAssessment',
        component: () => import("@/views/Page/KpiAssessment/KpiAssessment.vue"),
        meta: {
            title: 'Kpi Assessment',
        },
    }
];